"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ONETRUST_ENABLED = exports.ONETRUST_EXPERIMENT = exports.OPTANON_CATEGORY_PREFIX = exports.CONSENT_GROUP_PREFIX = exports.CONSENT_COOKIE = void 0;
exports.CONSENT_COOKIE = 'OptanonConsent';
exports.CONSENT_GROUP_PREFIX = 'groups=';
exports.OPTANON_CATEGORY_PREFIX = 'optanon-category-';
exports.ONETRUST_EXPERIMENT = 'privacy_compliance_onetrust';
exports.ONETRUST_ENABLED = '__oneTrustEnabled';
